import { createSlice } from "@reduxjs/toolkit";

const companiesSlice = createSlice({
  name: "companies",
  initialState: {
    // Listing
    data: [],
    totalRecords: 0,
    currentPage: 0,
    allBranchWhiteLabelCount: [],
    isLoading: true,
    error: null,

    // Access rights
    accessRights: { list: [], selectedIds: [], isError: false },

    // Features
    featureGroupOptions: [],
    companyFeature: null,
    featureStructure: null,

    // Plan
    planInfo: null,
    plans: [],

    // Branch management
    nodesWithWhiteLabel: null,
    totalBranches: 0,
    branchPage: 0,

    // Company users
    companyUsers: [],
    totalUsers: 0,
    usersPage: 0,
    usersLoading: false,

    // Expired date
    companyExpiredDate: null,

    // Reference data (static)
    industries: [],

    // Serial Number assign workflow
    productDropdown: [],
    branchDropdown: [],
    snFormatDropdown: [],
    snAvailabilityList: { data: [], isSNexceedRange: false },
    assignLoading: false,
  },
  reducers: {
    setCompaniesData(state, action) {
      state.data = action.payload.data || [];
      state.totalRecords = action.payload.totalRecords || 0;
      state.currentPage = action.payload.page || 0;
      state.allBranchWhiteLabelCount = action.payload.branchWhiteLabelCounts || [];
      state.isLoading = false;
    },
    setLoading(state, action) {
      state.isLoading = action.payload;
      if (action.payload) state.error = null;
    },
    setError(state, action) {
      state.error = action.payload;
      state.isLoading = false;
    },
    clearError(state) {
      state.error = null;
    },
    resetCompanies(state) {
      state.data = [];
      state.totalRecords = 0;
      state.isLoading = true;
    },
    setAccessRights(state, action) {
      state.accessRights.list = action.payload.list;
      state.accessRights.selectedIds = action.payload.selectedIds;
      state.accessRights.isError = false;
    },
    setAccessRightsError(state) {
      state.accessRights.isError = true;
    },
    resetAccessRights(state) {
      state.accessRights = { list: [], selectedIds: [], isError: false };
    },
    setFeatureGroupOptions(state, action) {
      state.featureGroupOptions = action.payload;
    },
    setCompanyFeature(state, action) {
      state.companyFeature = action.payload;
    },
    setFeatureStructure(state, action) {
      state.featureStructure = action.payload;
    },
    setPlanInfo(state, action) {
      state.planInfo = action.payload;
    },
    setPlans(state, action) {
      state.plans = action.payload;
    },
    setNodesWithWhiteLabel(state, action) {
      state.nodesWithWhiteLabel = action.payload.data;
      state.totalBranches = action.payload.total;
      state.branchPage = action.payload.page;
    },
    setCompanyUsers(state, action) {
      state.companyUsers = action.payload.data;
      state.totalUsers = action.payload.total;
      state.usersPage = action.payload.page;
      state.usersLoading = false;
    },
    setUsersLoading(state, action) {
      state.usersLoading = action.payload;
    },
    setCompanyExpiredDate(state, action) {
      state.companyExpiredDate = action.payload;
    },
    setIndustries(state, action) {
      state.industries = Array.isArray(action.payload) ? action.payload : [];
    },
    addBranchWhiteLabelCount(state, action) {
      state.allBranchWhiteLabelCount[action.payload] += 1;
    },
    minusBranchWhiteLabelCount(state, action) {
      state.allBranchWhiteLabelCount[action.payload] -= 1;
    },
    setProductDropdown(state, action) {
      state.productDropdown = action.payload || [];
    },
    setBranchDropdown(state, action) {
      state.branchDropdown = action.payload || [];
    },
    setSnFormatDropdown(state, action) {
      state.snFormatDropdown = action.payload || [];
    },
    setSnAvailabilityList(state, action) {
      state.snAvailabilityList.data = action.payload?.data || [];
      state.snAvailabilityList.isSNexceedRange = action.payload?.isSNexceedRange || false;
    },
    resetSNAvailabilityList(state) {
      state.snAvailabilityList = { data: [], isSNexceedRange: false };
    },
    resetProductDropdown(state) {
      state.productDropdown = [];
    },
    setAssignLoading(state, action) {
      state.assignLoading = action.payload;
    },
  },
});

export const {
  setCompaniesData,
  setLoading,
  setError,
  clearError,
  resetCompanies,
  setAccessRights,
  setAccessRightsError,
  resetAccessRights,
  setFeatureGroupOptions,
  setCompanyFeature,
  setFeatureStructure,
  setPlanInfo,
  setPlans,
  setNodesWithWhiteLabel,
  setCompanyUsers,
  setUsersLoading,
  setCompanyExpiredDate,
  setIndustries,
  addBranchWhiteLabelCount,
  minusBranchWhiteLabelCount,
  setProductDropdown,
  setBranchDropdown,
  setSnFormatDropdown,
  setSnAvailabilityList,
  resetSNAvailabilityList,
  resetProductDropdown,
  setAssignLoading,
} = companiesSlice.actions;
export default companiesSlice.reducer;
